module.exports = __webpack_public_path__ + "0dd16623d01f7edd2c6656019976b87d.svg";